import React from 'react';
import { PalletBox } from '../../../models/pallet-box';
import { ShipmentsTable } from '../../ShipmentsTable';
import { Columns } from '../../ShipmentsTable/InternalShipmentsTable';
import { PalletBoxShipmentsFilters } from './PalletBoxShipmentsFilters';

export interface PalletBoxShipmentModalProps {
  palletBox: PalletBox;
}

// tslint:disable-next-line:function-name
export function PalletBoxShipmentsModal(
  { palletBox }: PalletBoxShipmentModalProps,
) {
  return <>
    <ShipmentsTable
      isVoided={false}
      isSorted={true}
      hideColumns={[Columns.MANIFESTED_AT, Columns.STATUS]}
      initialSort={[['createdAt', 'DESC']]}
      FiltersComponent={PalletBoxShipmentsFilters}
      palletBoxId={palletBox.id}
    />
  </>;
}
